/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/hull': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.542 10.5H2.015l7.527 7.527zM9.542 9.5V1.973L2.015 9.5zM10.542 9.5h7.442l-7.442-7.443zM10.542 10.5v7.443l7.442-7.443z"/>'
  }
})
